import { Dictionary } from '@models/common';
import { create } from 'zustand';

interface ScrollPositionStoreProps {
  positions: Dictionary;
  updateScrollPostion: (key: string, value: number) => void;
}

export const useScrollPositionStore = create<ScrollPositionStoreProps>((set) => ({
  positions: {},
  updateScrollPostion: (key: string, value: number) => {
    set((state) => {
      const newPositions = { ...state.positions };
      newPositions[key] = value;
      return { positions: newPositions };
    });
  },
}));
